import Vue from 'vue';
import store from './../../store';
import adjustmentTransformer from './../../transformers/adjustment';
import paginationTransformer from '../../transformers/pagination';
import helpers from '../../utils/helpers';

const success = ({ data }, resolve) => {
  const adjustments = adjustmentTransformer.fetchCollection(data.data);
  const pagination = paginationTransformer.fetch(data.pagination);

  store.dispatch('fetchPaginatedAdjustments', { adjustments, pagination });
  resolve({ adjustments, pagination });
};

const failed = (error, reject) => reject(error);


export default (params = {}) => (
  new Promise((resolve, reject) => {
    Vue.$http.get(helpers.buildUrl('/adjustments', params))
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/adjustment/items.js